import { useEffect, useState } from 'react';
import PublicFormRenderer from '@/components/forms/PublicFormRenderer';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/** Embeds any published form by slug. Used on the homepage + website builder. */
export default function HomepageContactForm({ slug = 'homepage-contact', title, description }) {
  const [form, setForm] = useState(null);

  useEffect(() => {
    fetch(`${API}/forms/${slug}/schema`)
      .then((r) => r.ok ? r.json() : null)
      .then(setForm)
      .catch(() => {});
  }, [slug]);

  if (!form) return null;

  return (
    <section
      className="relative py-20 overflow-hidden bg-gradient-to-b from-[#0B0D2B] via-[#13153A] to-[#0B0D2B]"
      data-testid="homepage-contact-form"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/3 w-96 h-96 rounded-full bg-fuchsia-600/15 blur-3xl"></div>
        <div className="absolute bottom-0 right-1/3 w-96 h-96 rounded-full bg-cyan-500/15 blur-3xl"></div>
      </div>
      <div className="container-main relative">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-syne text-[1.6rem] xs:text-3xl sm:text-4xl md:text-5xl font-black text-white mb-3 tracking-tight">
              {title || form.title}
            </h2>
            {(description || form.description) && (
              <p className="text-zinc-300 text-sm sm:text-base font-outfit max-w-md mx-auto">
                {description || form.description}
              </p>
            )}
          </div>
          <div className="rounded-2xl bg-[#13153A]/70 backdrop-blur-xl border border-purple-500/25 p-6 sm:p-8 shadow-[0_20px_60px_-20px_rgba(217,70,239,0.4)]">
            <PublicFormRenderer form={form} embedded />
          </div>
        </div>
      </div>
    </section>
  );
}
